import { Pipe, PipeTransform } from '@angular/core';

const romanNumerals: { [key: number]: string } = {
  1: 'I', 4: 'IV', 5: 'V', 9: 'IX', 10: 'X',
  40: 'XL', 50: 'L', 90: 'XC', 100: 'C',
  400: 'CD', 500: 'D', 900: 'CM', 1000: 'M'
};

@Pipe({
  name: 'numToRoman',
  standalone: true,
})
export class NumToRomanPipe implements PipeTransform {

  transform(num: number | string): string {
    let val = +num;

    if (isNaN(val)) {
      return String(num);
    }

    let result = '';

    // Iterate over the values in descending order
    for (let value of Object.keys(romanNumerals).reverse()) {
      while (val >= +value) {
        result += romanNumerals[+value];
        val -= +value;
      }
    }

    return result;
  }

}
